import React, {Component} from 'react';
import './Activites.css';

class Activites extends Component {


    render() {
        return (

            <div id="activites" className="row home-block">

                <div>
                    <h2 className="title">My activities</h2>

                    <p>As part of and alongside my academic duties, I develop several activities:</p>

                    <ul>
                     <li><i className="fa fa-code"></i> Programming (Python, R)</li>
                     <li><i className="fa fa-book"></i> Educational consulting</li>
                     <li><i className="fa fa-book"></i> Teaching</li>
                     <li><i className="fa fa-area-chart"></i> Writing</li>
                     <li><i className="fa fa-graduation-cap"></i> Data Science</li>
                     <li><i className="fa fa-users"></i> Tutoring</li>
                    </ul>

                </div>

            </div>

        );
    }
}

export default Activites;



// WEBPACK FOOTER //
// ./src/Components/Activites/Activites.js